import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Grid, } from "@mui/material";
import { Typography, Divider } from "@mui/material";
import CustomButton from "../../../components/common/CustomButton";
import {
    ClearRounded,
    SaveRounded,
} from "@mui/icons-material";
import CustomTextField from "../../../components/common/CustomTextField";
import { Formik, } from "formik";
import * as Yup from "yup";
import { genericPost } from "../../../services/authServices";
import { ENQUIRY_SUBSCRIPTION_PLAN_CREATE } from "../../../services/apiRoutes";
import CustomStyle from "../../../components/common/CustomStyle";
import CustomAutocomplete from "../../../components/common/CustomAutoComplete";
import { getCurrencyList } from "../../../services/CommonServices";
import CustomPrefixSuffixField from "../../../components/common/CustomPrefixSuffixField";

const CreateSubscriptionPlan = ({
    handleClose,
    fetchData,
    setMessage,
}) => {
    const [currencyList, setCurrencyList] = useState([]);
    const [activeButton, setActiveButton] = useState('International');
    const [prefix, setPrefix] = useState('$');

    const [formData, setFormData] = useState({
        perMonthAmount: "",
        planActiveDate: "",
        planExpiredDate: "",
        baseAmount: "",
        companyPerMonth: "",
        currency: 233,
        plan: 1,

    });

    const validationSchema = Yup.object({
        perMonthAmount: Yup.string().required("Month Amount is required"),
        planActiveDate: Yup.string().required("plan Active Date is required"),
        planExpiredDate: Yup.string().required("plan Expired Date is required"),
        baseAmount: Yup.string().required("baseAmount is required"),
        companyPerMonth: Yup.string().required("Company Per Month is required"),
        currency: Yup.string().required("Currency is required"),
        plan: Yup.string().required("Plan is required"),

    });

    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
    }
    useEffect(() => {
        getCommonData();
    }, []);


    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const response = await genericPost(ENQUIRY_SUBSCRIPTION_PLAN_CREATE, values, {
            });
            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Create Subscription Plan successfully",
                    type: "success",
                });
                fetchData()
                setTimeout(() => {
                    handleClose()
                }, 3000)
                handleClose()
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };

    const planList = [
        { id: 1, title: 'International' },
        { id: 2, title: 'China' },
    ];

    return (
        <>
            <Formik
                initialValues={formData}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({
                    values,
                    handleChange,
                    handleSubmit,
                    errors,
                    touched,
                    isSubmitting,
                    setFieldValue

                }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={1} style={CustomStyle.container}>
                            <Grid item xs={4} md={6}>
                                <Typography sx={{ fontWeight: 600 }} style={CustomStyle.title}>
                                    Create Subscription Plan
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={6}
                                md={6}
                                style={{ display: "flex", justifyContent: "flex-end" }}
                            >
                                <Box style={{ display: "flex" }}>
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title={
                                            isSubmitting ? (
                                                <CircularProgress size={20} color="inherit" />
                                            ) : (
                                                "Save"
                                            )
                                        }
                                        size="small"
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                    <CustomButton
                                        startIcon={<ClearRounded />}
                                        title="Cancel"
                                        size="small"
                                        variant="contained"
                                        onClick={handleClose}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid
                            container
                            spacing={1}
                            style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: "5px" }}
                        >
                            <Grid item xs={12} sm={12} md={6}>
                                <CustomAutocomplete
                                    options={planList}
                                    fieldLabel="Plan"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={planList.find((option) => option.id === values.plan) || null}
                                    onChange={(e, newValue) => {
                                        const planId = newValue?.id || '';
                                        setFieldValue('plan', planId);
                                        if (planId === 1) {
                                            setPrefix('$');
                                            setFieldValue('currency', 233); // USD
                                        } else if (planId === 2) {
                                            setPrefix('¥');
                                            setFieldValue('currency', 45); // CNY
                                        } else {
                                            setPrefix('');
                                            setFieldValue('currency', '');
                                        }
                                        setFieldValue('baseAmount', '');
                                        setFieldValue('perMonthAmount', '');
                                        setFieldValue('companyPerMonth', '');
                                    }}
                                    placeholder="Select Plan"
                                    error={touched.plan && !!errors.plan}
                                    helperText={touched.plan && errors.plan}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <CustomAutocomplete
                                    options={currencyList}
                                    fieldLabel="Currency"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={currencyList.find((option) => option.id === values.currency) || null}
                                    onChange={(e, newValue) =>
                                        setFieldValue('currency', newValue ? newValue.id : '')
                                    }
                                    placeholder="Select Currency"
                                    error={touched.currency && !!errors.currency}
                                    helperText={touched.currency && errors.currency}
                                    readOnly={true}
                                    sx={CustomStyle.readOnly}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <CustomPrefixSuffixField
                                    prefix={prefix}
                                    tagLine="Includes 2 users and 1 company free"
                                    name="baseAmount"
                                    fieldLabel="Basic Subcription"
                                    value={values.baseAmount}
                                    onChange={handleChange}
                                    required={true}
                                    type="number"
                                    placeholder="Enter base Amount"
                                    error={touched.baseAmount && Boolean(errors.baseAmount)}
                                    helperText={touched.baseAmount && errors.baseAmount}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                                <CustomPrefixSuffixField
                                    prefix={prefix}
                                    name="perMonthAmount"
                                    fieldLabel="Additional User"
                                    tagLine="per month"
                                    value={values.perMonthAmount}
                                    onChange={handleChange}
                                    required={true}
                                    type="number"
                                    placeholder="Enter Per Month Amount"
                                    error={touched.perMonthAmount && Boolean(errors.perMonthAmount)}
                                    helperText={touched.perMonthAmount && errors.perMonthAmount}
                                />
                            </Grid>


                            <Grid item xs={12} sm={6} md={6}>
                                <CustomPrefixSuffixField
                                    prefix={prefix}
                                    name="companyPerMonth"
                                    fieldLabel="Additional Company"
                                    tagLine="per month"
                                    value={values.companyPerMonth}
                                    onChange={handleChange}
                                    required={true}
                                    type="number"
                                    placeholder="Enter Company Per Month"
                                    error={touched.companyPerMonth && Boolean(errors.companyPerMonth)}
                                    helperText={touched.companyPerMonth && errors.companyPerMonth}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <CustomTextField
                                    type="date"
                                    name="planActiveDate"
                                    fieldLabel="Plan Start"
                                    value={values.planActiveDate}
                                    onChange={handleChange}
                                    placeholder="Enter financialYearEnd"
                                    error={touched.planActiveDate && !!errors.planActiveDate}
                                    helperText={touched.planActiveDate && errors.planActiveDate}
                                    required={true}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <CustomTextField
                                    type="date"
                                    name="planExpiredDate"
                                    fieldLabel="Plan expired"
                                    value={values.planExpiredDate}
                                    onChange={handleChange}
                                    placeholder="Enter financialYearEnd"
                                    error={touched.planExpiredDate && !!errors.planExpiredDate}
                                    helperText={touched.planExpiredDate && errors.planExpiredDate}
                                    required={true}
                                />
                            </Grid>

                        </Grid>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default CreateSubscriptionPlan; 